import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { getTemporarySession } from '../temporary-sessions';

const getOrderRecipientURL = '/salesorders.v1.Public/GetOrderRecipientSession';
const getWorkOrderRecipientURL = '/salesorders.v1.Public/GetWorkOrderRecipientSession';

@Injectable()
export class TemporarySessionInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(getOrderRecipientURL) || request.url.includes(getWorkOrderRecipientURL)) {
      // this request returns a temporary session based on a token provided in the payload, we have no need for a Bearer Token or else it can result in a 403
      request = request.clone({
        setHeaders: {
          Authorization: '',
        },
      });
      return next.handle(request);
    }

    if (!this.router.url.startsWith('/public/')) {
      return next.handle(request);
    }

    const temporarySession = getTemporarySession();
    if (temporarySession) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${temporarySession}`,
        },
      });
    }
    return next.handle(request);
  }
}
